import { FrameworkConfiguration, Container } from 'aurelia-framework';
import { I18N, Backend, TCustomAttribute } from 'aurelia-i18n';
import { Router, RouteConfig } from 'aurelia-router';
import { PLATFORM } from 'aurelia-pal';

export async function configure(config: FrameworkConfiguration): Promise<void> {

  var i18n = Container.instance.get(I18N);
  await i18n.i18next.loadNamespaces([
    "Aqs.Common",
    "Aqs.Dashboard",
    "Aqs.Home",
    "Aqs.Issue",    
    "Aqs.News",
    "Aqs.Map",
    "Aqs.AirQualityIndex"
  ]);

  var router = config.aurelia.container.get(Router) as Router;
  let newRoutes: RouteConfig[] = [
    {
      route: ['Modules/Aqs/HomePage'],
      name: 'Home',
      href: 'Home',
      moduleId: PLATFORM.moduleName('Modules/Aqs/Programs/Home/HomeSearchVM'),
      title: 'Home',
      layoutViewModel: PLATFORM.moduleName('Layout/master-page'),
      layoutModel: { Code: 'Home', Root: 'public' },
      nav: true,
    },
    {
      route: ['Modules/Aqs/DashboardEgatPage'],
      name: 'Dashboard',
      href: 'Dashboard',
      moduleId: PLATFORM.moduleName('Modules/Aqs/Programs/DashboardEgat/DashboardSearchVM'),
      title: 'Dashboard',
      layoutViewModel: PLATFORM.moduleName('Layout/master-page-egat'),
      layoutModel: { Code: 'Dashboard', Root: 'public-egat' },
      nav: true,
    },
    {
      route: ['Modules/Aqs/EmissionMapGraphPublicPage'],
      name: 'EmissionMapGraphPublic',
      href: 'EmissionMapGraphPublic',
      moduleId: PLATFORM.moduleName('Modules/Aqs/Programs/EmissionMapGraphPublic/EmissionMapGraphPublicSearchVM'),
      title: 'EmissionMapGraphPublic',
      layoutViewModel: PLATFORM.moduleName('Layout/master-page'),
      layoutModel: { Code: 'EmissionMapGraphPublic', Root: 'public' },
      nav: true,
    },
    {
      route: ['Modules/Aqs/MapMonitoringEgatPage'],
      name: 'Map Monitoring',
      href: 'MapMonitoring',
      moduleId: PLATFORM.moduleName('Modules/Aqs/Programs/MapMonitoringEgat/MapMonitoringSearchVM'),
      title: 'Map Monitoring',
      layoutViewModel: PLATFORM.moduleName('Layout/master-page-egat'),
      layoutModel: { Code: 'MapMonitoringEgat', Root: 'public-egat' },
      nav: true,
    },
    {
      route: ['Modules/Aqs/MapMonitoringPage'],
      name: 'Map Monitoring',
      href: 'MapMonitoring',
      moduleId: PLATFORM.moduleName('Modules/Aqs/Programs/MapMonitoring/MapMonitoringSearchVM'),
      title: 'Map Monitoring',
      layoutViewModel: PLATFORM.moduleName('Layout/master-page'),
      layoutModel: { Code: 'MapMonitoring', Root: 'public' },
      nav: true,
    },
    {
      route: ['Modules/Aqs/AirQualityIndexPage'],
      name: 'Air Quality Index',
      href: 'AirQualityIndex',
      moduleId: PLATFORM.moduleName('Modules/Aqs/Programs/AirQualityIndex/AirQualityIndexSearchVM'),
      title: 'Air Quality Index',
      layoutViewModel: PLATFORM.moduleName('Layout/master-page'),
      layoutModel: { Code: 'AirQualityIndex', Root: 'public' },
      nav: true,
    },
    {
      route: ['Modules/Aqs/NewsPage'],
      name: 'News',
      href: 'News',
      moduleId: PLATFORM.moduleName('Modules/Aqs/Programs/News/NewsSearchVM'),
      title: 'News',
      layoutViewModel: PLATFORM.moduleName('Layout/master-page'),
      layoutModel: { Code: 'News', Root: 'public' },
      nav: true,
    },
    {
      route: ['Modules/Aqs/NewsPage/:Id'],
      moduleId: PLATFORM.moduleName('Modules/Aqs/Programs/News/NewsViewEditorVM'),
      name: 'News',
      href: '#',
      nav: true,
      title: 'News',
      layoutViewModel: PLATFORM.moduleName('Layout/master-page'),
      layoutModel: { Code: 'News', Root: 'public' },
    },
    {
      route: ['Modules/Aqs/IssuePage'],
      name: 'Issue',
      href: 'Issue',
      moduleId: PLATFORM.moduleName('Modules/Aqs/Programs/Issue/IssueEditorVM'),
      title: 'Issue',
      layoutViewModel: PLATFORM.moduleName('Layout/master-page'),
      layoutModel: { Code: 'Issue', Root: 'public' },
      nav: true,
    },
    {
      route: ['Modules/Aqs/DashboardPage'],
      name: 'Dashboard',
      href: 'Dashboard',
      moduleId: PLATFORM.moduleName('Modules/Aqs/Programs/Dashboard/DashboardSearchVM'),
      title: 'Dashboard',
      layoutViewModel: PLATFORM.moduleName('Layout/master-page'),
      layoutModel: { Code: 'Dashboard', Root: 'public' },
      nav: true,
    },
    {
      route: ['Modules/Aqs/FonduePage'],
      name: 'Fondue',
      href: 'Fondue',
      moduleId: PLATFORM.moduleName('Modules/Aqs/Programs/Fondue/FondueEditorVM'),
      title: 'Fondue',
      layoutViewModel: PLATFORM.moduleName('Layout/master-page'),
      layoutModel: { Code: 'Fondue', Root: 'public' },
      nav: true,
    },
    {
      route: ['Modules/Aqs/News2Page'],
      name: 'News2',
      href: 'News2',
      moduleId: PLATFORM.moduleName('Modules/Aqs/Programs/News2/News2SearchVM'),
      title: 'Official News',
      layoutViewModel: PLATFORM.moduleName('Layout/master-page-v2'),
      layoutModel: { Code: 'News2', Root: 'public' },
      nav: true,
    },
    {
      route: ['Modules/Aqs/News2Page/:Id'],
      moduleId: PLATFORM.moduleName('Modules/Aqs/Programs/News2/News2ViewEditorVM'),
      name: 'News2',
      href: '#',
      nav: true,
      title: 'Official News',
      layoutViewModel: PLATFORM.moduleName('Layout/master-page-v2'),
      layoutModel: { Code: 'News2', Root: 'public' },
    },

  ]

  newRoutes.forEach(newRoute => {
    router.addRoute(newRoute);
  });
}
